import { render, staticRenderFns } from "./Booth.vue?vue&type=template&id=c8a96eca"
import script from "./Booth.vue?vue&type=script&lang=js"
export * from "./Booth.vue?vue&type=script&lang=js"
import style0 from "./Booth.vue?vue&type=style&index=0&id=c8a96eca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports